import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommentDTO, MultiCommentDTO } from '../ma-comments-popup/comment-dto';
import { Plate } from '../models/plate';
import { BBResponseContainer } from '../carrier/response-container';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MaCommentsPopupService {
  PLATE_PREPARATION_API = environment.BB_SAMPLE_PROCESSING_API

  constructor(private httpClient: HttpClient) { }
  updateComment(commentDTO:CommentDTO){
    let url = this.PLATE_PREPARATION_API+'updatecomments';
    return this.httpClient.put<BBResponseContainer>(url,commentDTO).pipe(map(result => result.data as string));
  }

  checkIfPlateExists(labId: String, plateID: String){
    let url = this.PLATE_PREPARATION_API+'checkPlateExists/'+labId+"/"+plateID;
    return this.httpClient.get<any>(url);  
  }

  fetchPlate(plateID: string,labId:string){
    let url = this.PLATE_PREPARATION_API+'plate/'+labId+"/"+plateID;
    return this.httpClient.get<Plate>(url);
  }

  updateMultiComment(multiCommentDTO:MultiCommentDTO){
    let url = this.PLATE_PREPARATION_API+'updateMultipleComments';
    return this.httpClient.put<BBResponseContainer>(url,multiCommentDTO).pipe(map(result => result.data as string));
  }

  updateMultiCommentStatus(multiCommentDTO){
    let url = this.PLATE_PREPARATION_API+'updateMultipleCommentsStatus';
    return this.httpClient.put<BBResponseContainer>(url,multiCommentDTO).pipe(map(result => result.data as string));
  }

  commentDetailsbyPlateId(labId : string, plateId: string){
    let url = this.PLATE_PREPARATION_API+'commentDetailsbyPlateId/'+labId+"/"+plateId;
    return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data as Plate));
  }
}
